import { MutationTree } from 'vuex'

import { PaymentMethodsState, Mutations, PaymentMethod } from './types'

const mutations: MutationTree<PaymentMethodsState> = {
  [Mutations.SET_PAYMENT_METHODS](state, paymentMethods: PaymentMethod[]) {
    state.paymentMethods = paymentMethods
  },
}

export default mutations
